export enum Features {
  DASHBOARD_FEATURE = "dashboardFeature",
  VACATION_REPORT = "vacationReport",
  GANTT_GRAPH = "GanttGraph",
  ACCOMPLISHMENTS = "accomplishments",
  CERTIFICATIONS = "certifications"
}
